import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setModalTitle } from '../store/modal.actions';
export function useModalTitle(title) {
    const dispatch = useDispatch();
    useLayoutEffect(() => {
        dispatch(setModalTitle(title));
    }, [dispatch, title]);
}
//# sourceMappingURL=useModalTitle.js.map